const BASE =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_88de7ec9-ea3f-4fe0-8d17-1f6da2429080/artifacts";
const NB =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_wellness-jogja-24jam/artifacts";

export const IMG = {
  hero: `${BASE}/9yd5b0qh_file_000000004e0c820793f4c557fe27be1d.png`,
  kerokan: `${BASE}/bhyuv45i_1-1.jpg`,
  refleksi: `${BASE}/k1wh83ir_2-1.jpg`,
  fullbody: `${BASE}/vfzhhjhc_3-1.jpg`,
  totok: `${BASE}/ri2dfoln_4-1.jpg`,
  bodyscrub: `${NB}/je0asn3z_5-1.jpg`,
  galTraditional: `${NB}/fb7xd02g_file_000000004e0c820793f4c557fe27be1d.png`,
  galScrub: `${NB}/nu2atth6_file_00000000afec8207943c71639e25eb43.png`,
  galReflex: `${NB}/r4n4xi5p_file_00000000a3d08211b30afd2938169613.png`,
  galFacial: `${NB}/idpf5ev0_file_00000000d7a48207bc7662b8a983eccf.png`,
  ambience: `${NB}/fb7xd02g_file_000000004e0c820793f4c557fe27be1d.png`,
  batik:
    "https://images.unsplash.com/photo-1543874835-ad7d64196a07?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  locMalioboro:
    "https://images.unsplash.com/photo-1670156999223-33bce8274000?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  locKaliurang:
    "https://images.unsplash.com/photo-1650204972401-45f6aa9c85c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  locPrawirotaman:
    "https://images.unsplash.com/photo-1610008130921-4de5dbc591a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  locTugu:
    "https://images.unsplash.com/photo-1631795617958-3ddcf718d6aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const PARTNERS = [
  { name: "KJ Hotel Yogyakarta", logo: `${NB}/x4l5oouy_IMG-20250715-WA0519.jpg` },
  { name: "Swiss-Belboutique Yogyakarta", logo: `${NB}/24pc6wla_IMG-20250715-WA0523.jpg` },
  { name: "Hyatt Regency Yogyakarta", logo: `${NB}/wu4guiiz_IMG-20250715-WA0521.jpg` },
  { name: "Gallery Prawirotaman Hotel", logo: `${NB}/s2g9ai7e_IMG-20250715-WA0514.jpg` },
  { name: "Hotel Tentrem Yogyakarta", logo: `${NB}/63khhvv3_IMG-20250715-WA0513.jpg` },
  { name: "Marriott Yogyakarta", logo: `${NB}/arc3h58k_IMG-20250715-WA0518.jpg` },
  { name: "ibis Hotels Yogyakarta", logo: `${NB}/p5vwn3ga_IMG-20250715-WA0520.jpg` },
  { name: "Royal Ambarrukmo Yogyakarta", logo: `${NB}/wqoq3r4w_IMG-20250715-WA0522.jpg` },
  { name: "Greenhost Boutique Hotel", logo: `${NB}/yxc8uoas_IMG-20250715-WA0524.jpg` },
];

export const WA_NUMBER = "6283856307272";
export const WA_DISPLAY = "0838-5630-7272";
export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const BRAND = "Javanese Spa Jogja";

export const SERVICES = [
  {
    slug: "traditional-massage",
    name: "Traditional Massage",
    tag: "Warisan Jawa",
    image: IMG.fullbody,
    desc: "Massage tubuh penuh dengan teknik tradisional Jawa yang melancarkan peredaran darah, meluruhkan pegal, dan mengembalikan energi tubuh Anda.",
  },
  {
    slug: "reflexology",
    name: "Reflexology",
    tag: "Titik Refleksi",
    image: IMG.refleksi,
    desc: "Massage titik refleksi pada telapak kaki untuk menstimulasi organ tubuh, meredakan lelah, dan membawa rasa rileks yang mendalam.",
  },
  {
    slug: "massage-kerokan",
    name: "Massage + Kerokan",
    tag: "Hangat & Lega",
    image: IMG.kerokan,
    desc: "Perpaduan Massage tradisional dan kerokan untuk mengusir masuk angin, menghangatkan badan, serta melegakan pernapasan.",
  },
  {
    slug: "massage-totok-wajah",
    name: "Massage + Totok Wajah",
    tag: "Cerah & Segar",
    image: IMG.totok,
    desc: "Massage tubuh dilengkapi totok wajah untuk merelaksasi otot wajah, mencerahkan kulit, dan menghadirkan aura segar alami.",
  },
  {
    slug: "massage-body-scrub",
    name: "Massage + Body Scrub",
    tag: "Halus & Wangi",
    image: IMG.bodyscrub,
    desc: "Massage menenangkan dipadu lulur body scrub tradisional yang mengangkat sel kulit mati, menghaluskan, dan mengharumkan kulit.",
  },
];

export const DURATIONS = ["60 Menit", "90 Menit", "120 Menit"];

export const PACKAGES = [
  {
    name: "Paket Relaksasi Total",
    items: "Traditional Massage + Kerokan",
    desc: "Untuk badan yang benar-benar butuh istirahat total dan kehangatan.",
  },
  {
    name: "Paket Cantik & Bugar",
    items: "Massage + Totok Wajah + Body Scrub",
    desc: "Rawatan lengkap tubuh dan wajah dalam satu sesi yang memanjakan.",
  },
  {
    name: "Paket Sehat Kaki & Badan",
    items: "Reflexology + Traditional Massage",
    desc: "Kombinasi refleksi kaki dan Massage tubuh untuk kebugaran menyeluruh.",
  },
  {
    name: "Paket Royal Java",
    items: "Fullbody Massage + Body Scrub + Totok Wajah",
    desc: "Pengalaman ritual spa Jawa paling istimewa dari ujung kepala hingga kaki.",
  },
];

export const REASONS = [
  {
    no: "01",
    title: "Terapis Profesional & Bersertifikat",
    desc: "Setiap terapis kami terlatih, sopan, dan memegang sertifikat resmi. Tersedia pilihan terapis pria maupun wanita sesuai kenyamanan Anda.",
  },
  {
    no: "02",
    title: "Bebas Uang Transport",
    desc: "Berapa pun jarak di dalam Yogyakarta, tidak ada biaya transport tambahan. Harga yang Anda bayar adalah harga treatment.",
  },
  {
    no: "03",
    title: "Buka 24 Jam Setiap Hari",
    desc: "Butuh Massage tengah malam sepulang perjalanan? Kami siap datang kapan pun Anda membutuhkan, tanpa batas jam.",
  },
  {
    no: "04",
    title: "Datang ke Tempat Anda",
    desc: "Hotel, rumah, villa, atau penginapan di mana pun Anda berada di Jogja — cukup rebahan, biar kami yang datang.",
  },
];

export const AREAS = [
  {
    slug: "malioboro",
    name: "Malioboro",
    short: "Jantung kota Jogja",
    hero: IMG.locMalioboro,
    blurb:
      "Massage panggilan area Malioboro dan sekitarnya. Ideal untuk tamu hotel di kawasan pusat kota yang ingin melepas lelah setelah seharian berjalan menyusuri jalan legendaris ini.",
    landmarks: [
      "Hotel & guest house sepanjang Jalan Malioboro",
      "Titik Nol Kilometer & Alun-alun Utara",
      "Stasiun Tugu & sekitarnya",
      "Kawasan Sosrowijayan",
    ],
  },
  {
    slug: "kaliurang",
    name: "Kaliurang",
    short: "Sejuk kaki Merapi",
    hero: IMG.locKaliurang,
    blurb:
      "Massage panggilan area Kaliurang dan lereng Merapi. Sempurna untuk Anda yang menginap di villa sejuk dan ingin memanjakan tubuh ditemani udara pegunungan.",
    landmarks: [
      "Villa & resort kawasan Kaliurang",
      "Wisata Merapi & Tlogo Putri",
      "Penginapan area Pakem",
      "Kawasan UII & sekitarnya",
    ],
  },
  {
    slug: "prawirotaman",
    name: "Prawirotaman",
    short: "Kampung turis klasik",
    hero: IMG.locPrawirotaman,
    blurb:
      "Massage panggilan area Prawirotaman, surganya boutique hotel dan homestay. Layanan cepat dan profesional untuk wisatawan lokal maupun mancanegara.",
    landmarks: [
      "Boutique hotel & homestay Prawirotaman",
      "Kawasan Tirtodipuran",
      "Pusat kuliner & kafe turis",
      "Dekat Keraton & Taman Sari",
    ],
  },
  {
    slug: "tugu",
    name: "Tugu",
    short: "Ikon utara Jogja",
    hero: IMG.locTugu,
    blurb:
      "Massage panggilan area Tugu Jogja dan sekitarnya. Praktis untuk tamu hotel dekat Stasiun Tugu maupun warga sekitar landmark ikonik kota yang ingin bersantai tanpa perlu keluar rumah.",
    landmarks: [
      "Tugu Pal Putih & sekitarnya",
      "Hotel dekat Stasiun Tugu",
      "Kawasan Jl. Mangkubumi & Jetis",
      "Area Kotabaru & Gowongan",
    ],
  },
];

export const FAQS = [
  {
    q: "Apakah bisa memilih terapis pria atau wanita?",
    a: "Tentu. Saat booking, cukup sampaikan preferensi Anda — terapis pria atau wanita — dan kami akan mengaturkan sesuai permintaan Anda demi kenyamanan penuh.",
  },
  {
    q: "Bagaimana cara booking-nya?",
    a: "Sangat mudah. Klik tombol WhatsApp di halaman ini, lalu beri tahu kami: lokasi Anda, treatment yang diinginkan, durasi (60/90/120 menit), preferensi terapis, dan jam kedatangan. Terapis akan segera menuju tempat Anda.",
  },
  {
    q: "Apakah benar-benar bebas uang transport?",
    a: "Benar. Untuk seluruh area Yogyakarta tidak ada biaya transport tambahan. Anda hanya membayar treatment yang dipilih.",
  },
  {
    q: "Jam berapa saja layanan tersedia?",
    a: "Kami buka 24 jam setiap hari, termasuk dini hari dan hari libur. Kapan pun Anda butuh, kami siap datang.",
  },
  {
    q: "Ke mana saja terapis bisa datang?",
    a: "Hotel, rumah, kos, apartemen, villa, maupun penginapan di seluruh Yogyakarta seperti Malioboro, Kaliurang, Prawirotaman, dan Tugu.",
  },
  {
    q: "Berapa harga tiap treatment?",
    a: "Harga menyesuaikan treatment dan durasi yang dipilih. Silakan hubungi kami via WhatsApp untuk informasi harga terbaru — tim kami akan membantu dengan senang hati.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Anya G.",
    area: "Tamu hotel, Malioboro",
    text: "Terapisnya sopan dan profesional banget. Datang tepat waktu tengah malam sepulang kerja, badan langsung enteng. Benar-benar bebas biaya transport!",
  },
  {
    name: "Rian S.",
    area: "Villa, Kaliurang",
    text: "Pesan Traditional Massage 120 menit untuk sekeluarga di villa. Bisa pilih terapis wanita, pelayanan rapi dan bikin rileks. Pasti pesan lagi.",
  },
  {
    name: "Michelle T.",
    area: "Homestay, Prawirotaman",
    text: "Booking lewat WhatsApp gampang, balasannya cepat. Reflexology-nya juara, kaki yang pegal setelah keliling Jogja langsung segar lagi.",
  },
  {
    name: "Bagus P.",
    area: "Rumah, Tugu",
    text: "Massage + Kerokan-nya mantap saat masuk angin. Terapis ramah, alat bersih, dan datang ke rumah tanpa ribet. Recommended untuk warga Jogja.",
  },
];
